import { LazyMotion, domAnimation } from "framer-motion";
import { ReactNode } from "react";

// LazyMotion with domAnimation feature bundle reduces framer-motion bundle size
// by only including the DOM animation features needed for web, excluding:
// - Projection/layout animations (create-projection-node.mjs)
// - Drag gestures (VisualElementDragControls.mjs, PanSession.mjs)
// - Advanced sequence animations (animation/sequence/create.mjs)
// This can reduce the motion bundle by ~40-50%

interface MotionProviderProps {
  children: ReactNode;
}

export const MotionProvider = ({ children }: MotionProviderProps) => {
  return (
    <LazyMotion features={domAnimation} strict>
      {children}
    </LazyMotion>
  );
};
